<template>
  <div>
    <titulo-modulo titulo="Plano de Saúde" />
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <template v-else>
      <v-tabs
        v-model="tab"
        class="mt-2"
        grow
        background-color="green lighten-4"
        active-class="font-weight-bold subtitle-1"
        slider-size="3"
      >
        <v-tab>Meu Plano</v-tab>
        <v-tab>
          Solicitações
          <v-badge
            v-if="nroSolicsPendentes() > 0"
            :content="nroSolicsPendentes()"
            color="yellow darken-2"
          ></v-badge>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <meu-plano-saude v-if="meuPlano" />
              <v-btn
                v-if="meuPlano && podeAlterarIncluir"
                color="info"
                rounded
                block
                min-width="200"
                class="mt-3"
                :to="{ path: '/simular-plano-saude' }"
                >Simular outros planos</v-btn
              >
              <template v-else>
                <v-alert
                  v-if="solicitacoes.filter((s) => s.corrigir_docs).length > 0"
                  type="warning"
                  text
                >
                  Atenção! Você possui solicitações com pendências.
                </v-alert>
                <v-alert
                  type="info"
                  class="mt-2"
                  text
                  v-else-if="nroSolicsPendentes() > 0"
                  >Plano solicitado! Aguarde as próximas etapas.</v-alert
                >
                <template v-else>
                  <v-alert type="info" text class="mt-2"
                    >Você ainda não possui nenhum plano</v-alert
                  >
                  <v-btn
                    color="info"
                    rounded
                    block
                    min-width="200"
                    :to="{ path: '/simular-plano-saude' }"
                    >Simular um plano</v-btn
                  >
                </template>
              </template>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <minhas-solicitacoes />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import MeuPlanoSaude from "./components/MeuPlanoSaude.vue";
import MinhasSolicitacoes from "./components/MinhasSolicitacoes.vue";
export default {
  components: { TituloModulo, MeuPlanoSaude, MinhasSolicitacoes },
  computed: mapState("planoSaude", [
    "meuPlano",
    "solicitacoes",
    "podeAlterarIncluir",
  ]),
  data: () => ({
    loading: true,
    tab: 0,
  }),
  methods: {
    ...mapActions("planoSaude", ["getMeuPlano", "getSolicitacoes"]),
    isMobile() {
      return this.$mq == "sm";
    },
    nroSolicsPendentes() {
      return this.solicitacoes.filter((s) => !s.status_final).length;
    },
  },
  async created() {
    this.loading = true;
    await this.getMeuPlano();
    await this.getSolicitacoes();
    this.loading = false;
  },
};
</script>

<style></style>
